import React from "react";

interface Props {
  url: string;
}

const Permissions = ({ url }: Props) => {
  const handleClickUser = (): void => {
    window.location.href = `${url}/sendnotification`;
  };

  return (
    <div className="permissions">
      <h1>Permission admin validée</h1>

      <div className="permissions-container">
        <div>Il est maintenant possible de requêter le tenant client à n'importe quel moment</div>
        <div>Quelle que soit la méthode utilisée précédemment (id de tenant renseigné ou non), le serveur aura reçu l'id du tenant client dans la réponse à la demande de validation admin</div>
        <button className="home-button" onClick={handleClickUser}>
          Etape suivante
        </button>
      </div>
    </div>
  );
};

export default Permissions;
